import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, Link } from 'react-router-dom'
import { logout } from 'src/store/actions/user'

import './UserSettings.sass'

const UserSettings = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [visible, setVisible] = useState(false)
  const name = useSelector((s: any) => s.user?.username)

  const handleLogout = e => {
    e.preventDefault()
    dispatch(logout())
    history.push('/')
  }

  return (
    <div className="user-settings">
      <button className="filled" onClick={() => setVisible(!visible)}>
        <span className="icon icon-user" />
        <span className="name">{name}</span>
      </button>
      <ul className={`bubble ${visible ? 'visible' : ''}`}>
        <li>
          <Link to="/profile">
            <span className="icon icon-pencil" />
            <span><FormattedMessage id="user-settings.edit" /></span>
          </Link>
        </li>
        <li>
          <a href="/securitas-ada-user.pdf" download="manual-ada-user">
            <span className="icon icon-info" />
            <span><FormattedMessage id="user-settings.manual" /></span>
          </a>
        </li>
        <li onClick={handleLogout}>
          <div className="text">
            <span className="icon icon-logout" />
            <span><FormattedMessage id="logout" /></span>
          </div>
        </li>
      </ul>
    </div>
  )
}

export default UserSettings
